<template>
  <i
    v-show="showHeart && !$rsGlobals.$isListingScoresDisabled"
    :id="`${id}_heart`"
    class="far fa-heartbeat ml-1 mt-1"
  >
    <RsTooltip
      :target="`${id}_heart`"
      position="right"
      :title="title"
    />
  </i>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsListingScoreHeart',

  props: {
    id: {
      type: String,
      default: 'ls',
    },
    showHeart: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Complete this field to improve your listing score.',
    },
  },
});
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
  .fa-heartbeat{
    color: $error;
  }
</style>
